import React from "react";
import PropTypes from "prop-types";

import Image from "../../Atoms/Image";
import { FlexDiv } from "../../Atoms";
import Typography from "../../../foundation/Typography/V2";
import theme from "../../../foundation/Theme";

import { StyledSuccessModal, ImageHolder } from "./style";

const SuccessModal = ({
  successImage,
  submissionTitle,
  submissionSubtitle,
  submissionExtraText,
  subtitleVariant,
  className,
  isWebinar,
  mb = isWebinar ? "16px" : "24px",
}) => {
  return (
    <StyledSuccessModal
      id="requestCallbackSuccessModal"
      className={`callback-message-wrapper ${className}`}
      aria-labelledby="requestCallbackSuccessModal"
    >
      <FlexDiv className="image-container">
        <ImageHolder>
          {successImage && (
            <Image
              src={successImage}
              maxWidth="131px"
              width="100%"
              height="100%"
              maxHeight="105px"
            />
          )}
        </ImageHolder>
      </FlexDiv>
      <FlexDiv className="text-container">
        <Typography
          variant="heading5"
          color={theme.colorsV2.primary.shade_800}
          mb={mb}
          dangerouslySetInnerHTML={{ __html: submissionTitle }}
        />
        <Typography
          variant={subtitleVariant}
          color={theme.colorsV2.gray.shade_500}
          mb={mb}
          dangerouslySetInnerHTML={{ __html: submissionSubtitle }}
        />
        {submissionExtraText && (
          <Typography
            variant={subtitleVariant}
            color={theme.colorsV2.gray.shade_500}
          >
            {submissionExtraText}
          </Typography>
        )}
      </FlexDiv>
    </StyledSuccessModal>
  );
};

SuccessModal.propTypes = {
  successImage: PropTypes.string,
  submissionTitle: PropTypes.string,
  submissionSubtitle: PropTypes.string,
  submissionExtraText: PropTypes.string,
  mb: PropTypes.string,
  subtitleVariant: PropTypes.string,
  className: PropTypes.string,
};

SuccessModal.defaultProps = {
  successImage:
    "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/Success.svg",
  submissionTitle: "Form submitted</br>Thank you for your interest.",
  submissionSubtitle:
    "Our team will get in touch within 24hrs. We look forward to welcoming you to our family &#128522;",
  submissionExtraText: "Say farewell to unwell! #betheshyft",
  subtitleVariant: "label1",
  className: "label1",
};

export default SuccessModal;
